import { render, staticRenderFns } from "./CustomerGroupCreate.vue?vue&type=template&id=0218c90a&"
import script from "./CustomerGroupCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports